import { shareMediaConstants as smc } from "./constants"

const initialState = {
    loading: false,
    error: null,
    conversations: [],
    conversationsStat: {},
    success: false
}

export function shareMedia(state = initialState, action) {
    switch (action.type) {
        // Access
        case smc.GET_CONVS_TO_SHARE_REQUEST: {
            const { isPagination } = action
            return {
                ...state,
                loading: true,
                error: null,
                conversations: isPagination ? [...state.conversations] : [],
                conversationsStat: isPagination ? { ...state.conversationsStat } : {},
                error: null,
            }
        }
        case smc.GET_CONVS_TO_SHARE_SUCCESS: {
            const { stats, list, search } = action.updatedResponse
            let updatedList = [...state.conversations]

            if (action.updatedResponse.isPagination && list) {
                updatedList = [...state.conversations, ...list]
            } else if (state.conversations.length === 0 || search.length === 0) {
                updatedList = list ? [...list] : []
            }

            return {
                ...state,
                conversations: updatedList,
                conversationsStat: stats && { ...stats },
                loading: false,
                error: null,
            }
        }
        case smc.GET_CONVS_TO_SHARE_FAILURE:
            return {
                ...state,
                loading: false,
                conversations: [],
                error: action.error,
                conversationsStat: {},
            }
        case smc.SEARCH_CONVS_TO_SHARE_REQUEST: {
            const { isPagination } = action

            return {
                ...state,
                loading: true,
                error: null,
                conversations: isPagination ? [...state.conversations] : [],
                conversationsStat: isPagination ? { ...state.conversationsStat } : {},
            }
        }
        case smc.SEARCH_CONVS_TO_SHARE_SUCCESS: {
            const { stats, messages, search, conversations } = action.updatedResponse
            let updatedList = [...state.conversations]

            if (action.updatedResponse.isPagination && conversations) {
                updatedList = [...state.conversations, ...conversations]
            } else if (search.length >= 2 || state.conversations.length === 0) {
                updatedList = conversations ? [...conversations] : []
            }

            return {
                ...state,
                conversations: updatedList,
                conversationsStat: stats && { ...stats },
                loading: false,
                error: null,
            }
        }
        case smc.SEARCH_CONVS_TO_SHARE_FAILURE:
            return {
                ...state,
                loading: false,
                conversations: [],
                conversationsStat: {},
                error: action.error.cancelError ? null : action.error,
            }
        case smc.SEND_MEDIA_FILE_REQUEST:
            return {
                ...state,
                loading: true,
                success: false,
                error: null,
            }
        case smc.SEND_MEDIA_FILE_SUCCESS: {
            const { isLastConversation } = action.updatedResponse
            return {
                ...state,
                loading: false,
                success: isLastConversation,
                error: null,
            }
        }
        case smc.SEND_MEDIA_FILE_FAILURE:
            return {
                ...state,
                loading: false,
                success: false,
                error: action.error,
            }



        default:
            return state
    }
}
